import { ANO_CALENDARIO, calendarioUrl } from '../../config/anoLetivo';
import '../css/CalendarioImagens.css';

// Imagens do calendário escolar com opção de ampliar (toque/clique abre a
// imagem inteira em outra aba, onde dá para dar zoom) e de baixar.
// paginas: lista de arquivos dentro de public/assets/images/calendarios/ANO/
const CalendarioImagens = ({ segmento, paginas }) => {
  const nomeArquivo = (i) =>
    `Calendario-${ANO_CALENDARIO}-${segmento.replace(/\s+/g, '-')}-pagina-${i + 1}.png`;

  return (
    <div className="calendario-imagens">
      <p className="calendario-dica">Clique ou toque na imagem para ampliar.</p>
      <div className="imagens-calend">
        {paginas.map((arquivo, i) => (
          <a key={arquivo} href={calendarioUrl(arquivo)} target="_blank" rel="noreferrer" className="calendario-link">
            <img
              src={calendarioUrl(arquivo)}
              alt={`Calendário ${ANO_CALENDARIO} do ${segmento} - página ${i + 1}`}
              loading="lazy"
            />
          </a>
        ))}
      </div>
      <div className="calendario-baixar">
        {paginas.map((arquivo, i) => (
          <a key={arquivo} href={calendarioUrl(arquivo)} download={nomeArquivo(i)} className="calendario-botao">
            ⬇ Baixar página {i + 1}
          </a>
        ))}
      </div>
    </div>
  );
};

export default CalendarioImagens;
